import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Container from "../../../../../base/components/container.js";

import I18n from "../../../../../base/i18n.js.jsx";

import BarDiagram from "./bar_diagram.js";
import DoughnutDiagram from "./doughnut_diagram.js";

const blockStyles = makeStyles(theme => ({
  root: {
    ['@media (max-width: 768px)']: {
      paddingLeft: "24px",
      paddingRight: "24px"
    },
  },
  title: {
    color: theme.palette.greenMain,
    marginBottom: "24px",
    ['@media (max-width: 768px)']: {
      color: theme.palette.greenMiddle,
      marginBottom: "36px",
    },
  },
}));

const FinancingStructureBlock = props => {
  const classes = blockStyles();
  const { className, project } = props;
  const { amountOfBankCredit, amountOfOwnCapital, cost } = project

  const [ ownCapital, bankCredit, totalCost ] = [ +amountOfOwnCapital, +amountOfBankCredit, +cost ]
  const investments = totalCost - ownCapital - bankCredit;

  const calcPercent = value => {
    if(totalCost) {
      return (( value * 100 ) / totalCost).toFixed(2)
    }
  }

  let columns = [
  ];

  if(Boolean(bankCredit)) {
    columns.push({
      key: "bankCredit",
      name: I18n.t("web.page.project.financing_structure.bank_credit"),
      value: bankCredit,
      percentValue: calcPercent(bankCredit),
      color: '#C27100'
    })
  }
  if(Boolean(investments)) {
    columns.push({
      key: "investments",
      name: I18n.t("web.page.project.financing_structure.investments"),
      value: investments,
      percentValue: calcPercent(investments),
      color: '#004876',
    })
  }
  if(Boolean(ownCapital)) {
    columns.push({
      key: "ownCapital",
      name: I18n.t("web.page.project.financing_structure.own_capital"),
      value: ownCapital,
      percentValue: calcPercent(ownCapital),
      color: '#858585'
    })
  }
  return <React.Fragment />

  return (
    <Container className = { clsx(classes.root, className) } >
      <h3 className = { classes.title }>
        { I18n.t("web.page.project.financing_structure.title") }
      </h3>
      <BarDiagram columns = { columns }
                  totalCost = { totalCost } />
    </Container>
  );
}

export default FinancingStructureBlock;
